import { limparInstagram } from "./contatoLoja";

// Perfil do cliente final na loja pública: nome e celular são obrigatórios,
// Instagram é opcional. Mesma regra de celular do cadastro (LoginCliente):
// DDD + número, 10 ou 11 dígitos.

export const celularDigitos = valor => String(valor || "").replace(/\D/g, "").slice(0, 11);

export const formatarCelular = valor => {
  const n = celularDigitos(valor);
  if (n.length <= 2) return n;
  if (n.length <= 7) return `(${n.slice(0, 2)}) ${n.slice(2)}`;
  const corte = n.length === 10 ? 6 : 7;
  return `(${n.slice(0, 2)}) ${n.slice(2, corte)}-${n.slice(corte)}`;
};

// Data local (não UTC) no formato do <input type="date">: AAAA-MM-DD.
export const dataHoje = (agora = new Date()) =>
  `${agora.getFullYear()}-${String(agora.getMonth() + 1).padStart(2, "0")}-${String(agora.getDate()).padStart(2, "0")}`;

/** "" quando a data de nascimento é válida; senão a mensagem de erro. Obrigatória. */
export function validarDataNascimento(valor, agora = new Date()) {
  const texto = String(valor || "").trim();
  if (!texto) return "Informe sua data de nascimento.";
  const partes = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);
  if (!partes) return "Data de nascimento inválida.";
  const [ano, mes, dia] = partes.slice(1).map(Number);
  const data = new Date(Date.UTC(ano, mes - 1, dia));
  const existe = data.getUTCFullYear() === ano && data.getUTCMonth() === mes - 1 && data.getUTCDate() === dia;
  if (!existe || ano < 1900) return "Data de nascimento inválida.";
  if (texto > dataHoje(agora)) return "A data de nascimento não pode ser no futuro.";
  return "";
}

/** Valida e normaliza. `erros` só tem as chaves com problema; `valores` é o que deve ser gravado. */
export function validarPerfil({ nome, celular, dataNasc, instagram }, agora = new Date()) {
  const erros = {};
  const nomeLimpo = String(nome || "").trim().replace(/\s+/g, " ");
  const digitos = celularDigitos(celular);
  const nascimento = String(dataNasc || "").trim();
  const bruto = String(instagram || "").trim();
  const usuario = limparInstagram(bruto);

  if (!nomeLimpo) erros.nome = "Informe seu nome.";
  else if (nomeLimpo.length > 120) erros.nome = "Use no máximo 120 caracteres no nome.";
  if (digitos.length < 10) erros.celular = "Informe um celular com DDD (10 ou 11 dígitos).";
  const erroNascimento = validarDataNascimento(nascimento, agora);
  if (erroNascimento) erros.dataNasc = erroNascimento;
  if (bruto && !usuario) erros.instagram = "Informe só o usuário do Instagram, por exemplo @sualoja.";

  return { erros, valores: { nome: nomeLimpo, celular: digitos, dataNasc: nascimento, instagram: usuario } };
}
